import { consoleSandbox } from '@sentry/utils';

/**
 * This is a shim for the BrowserTracing integration.
 * It is needed in order for the CDN bundles to continue working when users add/remove tracing
 * from it, without changing their config. This is necessary for the loader mechanism.
 *
 * @deprecated Use `browserTracingIntegration()` instead.
 */
class BrowserTracingShim  {
  /**
   * @inheritDoc
   */
   static __initStatic() {this.id = 'BrowserTracing';}

  /**
   * @inheritDoc
   */

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
   constructor(_options) {
    // eslint-disable-next-line deprecation/deprecation
    this.name = BrowserTracingShim.id;

    consoleSandbox(() => {
      // eslint-disable-next-line no-console
      console.warn('You are using new BrowserTracing() even though this bundle does not include tracing.');
    });
  }

  /** jsdoc */
   setupOnce() {
    // noop
  }
} BrowserTracingShim.__initStatic();

/**
 * This is a shim for the BrowserTracing integration.
 * It is needed in order for the CDN bundles to continue working when users add/remove tracing
 * from it, without changing their config. This is necessary for the loader mechanism.
 */
function browserTracingIntegrationShim(_options) {
  // eslint-disable-next-line deprecation/deprecation
  return new BrowserTracingShim({});
}

/** Shim function */
function addTracingExtensions() {
  // noop
}

export { BrowserTracingShim as BrowserTracing, addTracingExtensions, browserTracingIntegrationShim as browserTracingIntegration };
//# sourceMappingURL=BrowserTracing.js.map
